export default {
  'primary-newsletter-button-cta-label': 'Subscribe to my newsletter',
}
